"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificateFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var CertificateFactory = /** @class */ (function (_super) {
    __extends(CertificateFactory, _super);
    function CertificateFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    CertificateFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    CertificateFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    CertificateFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    CertificateFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    CertificateFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return CertificateFactory;
}(contracts_1.ContractFactory));
exports.CertificateFactory = CertificateFactory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: '_auth',
                type: 'address',
            },
        ],
        name: 'Authorities',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'bytes32',
                name: 'hashedinput',
                type: 'bytes32',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'doner',
                type: 'address',
            },
        ],
        name: 'Donate',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'bytes32',
                name: 'hashedinput',
                type: 'bytes32',
            },
            {
                indexed: false,
                internalType: 'address',
                name: '_signer',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'address',
                name: '_verifier',
                type: 'address',
            },
        ],
        name: 'RegisterCertificates',
        type: 'event',
    },
    {
        inputs: [
            {
                internalType: 'string',
                name: '_name',
                type: 'string',
            },
            {
                internalType: 'string',
                name: '_website',
                type: 'string',
            },
            {
                internalType: 'string',
                name: '_image',
                type: 'string',
            },
        ],
        name: 'addAuthority',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        name: 'authorities',
        outputs: [
            {
                internalType: 'string',
                name: 'name',
                type: 'string',
            },
            {
                internalType: 'string',
                name: 'website',
                type: 'string',
            },
            {
                internalType: 'string',
                name: 'image',
                type: 'string',
            },
            {
                internalType: 'enum Certificate.List',
                name: 'status',
                type: 'uint8',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        name: 'certificates',
        outputs: [
            {
                internalType: 'string',
                name: 'hash',
                type: 'string',
            },
            {
                internalType: 'address',
                name: 'Signer',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'Verifier',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'Balance',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'input',
                type: 'bytes32',
            },
        ],
        name: 'collect',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'input',
                type: 'bytes32',
            },
        ],
        name: 'donate',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'input',
                type: 'bytes32',
            },
        ],
        name: 'getBalance',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'string',
                name: '_hash',
                type: 'string',
            },
            {
                internalType: 'bytes',
                name: '_signature',
                type: 'bytes',
            },
            {
                internalType: 'address',
                name: '_Signer',
                type: 'address',
            },
        ],
        name: 'registerCertificates',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes',
                name: 'sig',
                type: 'bytes',
            },
        ],
        name: 'splitSignature',
        outputs: [
            {
                internalType: 'uint8',
                name: '',
                type: 'uint8',
            },
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'pure',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'string',
                name: 'message',
                type: 'string',
            },
            {
                internalType: 'bytes',
                name: 'signature',
                type: 'bytes',
            },
        ],
        name: 'verifyString',
        outputs: [
            {
                internalType: 'address',
                name: 'signer',
                type: 'address',
            },
        ],
        stateMutability: 'pure',
        type: 'function',
    },
];
var _bytecode = '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';
//# sourceMappingURL=CertificateFactory.js.map